export default "__VITE_ASSET__f27354ab__"